import React from "react";
import styles from "./Loader.module.css";

function TableLoader() {
  return (
    <div
      className={styles.table_inner}
      style={{
        background: "white",
        border: "1px solid #E0E0E0",
      }}
    >
      {[1, 2, 3, 4, 5].map((row) => (
        <div
          key={row}
          className={styles.table_header_wrapper}
          style={{
            background: "white",
            border: "1px solid #F0F0F0",
          }}
        >
          <div className={styles.table_header}>
            {[1, 2, 3, 4, 5].map((col) => (
              <div
                key={col}
                className={styles.table_column}
                style={{
                  background: "#F5F5F5",
                  height: "45px",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    height: "12px",
                    background: "#E0E0E0",
                  }}
                ></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default TableLoader;
